// The `./ehr` door's transport seam.
//
// Every api module here resolves its client through the `@heidi/api` configured
// -client registry rather than importing the app's `@/utils/scribeHTTP`
// singleton, so the returned instance IS the app's real `scribeHttpV2` —
// same interceptors, same auth/workspace/tracing headers, same error handler.
// Request behaviour is byte-identical to the hub it was carved from.
//
// NOT `loadInboxHttp`. `./document-inbox` mints its OWN axios instance behind a
// loader seam because inbox-service is a different service with a different
// base URL and auth story; every endpoint on this door is ml-scribe, so the
// scribe client family is the correct transport. The in-domain precedent is
// `src/features/integrations-ehr/emis-patient-link/search-integration-patients.ts`,
// which already called `getScribeHttpClients().scribeHttpV2` this way.
//
// The accessors are FUNCTIONS, not module-level constants: the registry is
// populated by the app at boot (`src/utils/scribeHTTP.ts` -> `setScribeHttpClients`),
// and capturing the instance at module-evaluation time would read the registry
// before it is set for any module the app imports early.
import { getScribeHttpClients } from '@heidi/api/client';

/** The app's `scribeHttpV2` axios instance (`/api/v2/ml-scribe/`). */
export const http = () => getScribeHttpClients().scribeHttpV2;

/**
 * The app's `scribeHttpV2_1` axios instance (`/api/v2-1/ml-scribe/`). One
 * endpoint on this door uses it — `getIntegrationAvailableStandardizedSectionsV21`
 * — and it is a genuinely different base URL, not a naming variant.
 */
export const httpV2_1 = () => getScribeHttpClients().scribeHttpV2_1;
